import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45f7a454"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wizard-history card no-border background-fb" }
const _hoisted_2 = { class: "card-header popper-header wizard-history-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wizard-history-heading" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "wizard-history-title" }, "Your chats"),
  /*#__PURE__*/_createElementVNode("p", { class: "wizard-history-subtitle" }, " Pick up an older conversation or start fresh. ")
], -1))
const _hoisted_4 = {
  key: 0,
  class: "wizard-history-state"
}
const _hoisted_5 = {
  key: 1,
  class: "wizard-history-state"
}
const _hoisted_6 = {
  key: 2,
  class: "wizard-history-list"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "wizard-history-topline" }
const _hoisted_9 = { class: "wizard-history-mode" }
const _hoisted_10 = { class: "wizard-history-preview" }
const _hoisted_11 = { class: "wizard-history-date" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("button", {
        class: "btn btn-link wizard-history-new",
        type: "button",
        title: "New chat",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('new-chat')))
      }, [
        _createVNode(_component_font_awesome_icon, { icon: "plus" })
      ])
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Loading conversations... "))
      : (_ctx.sessions.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, " No conversations yet. "))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sessions, (session) => {
              return (_openBlock(), _createElementBlock("button", {
                key: session.sessionId,
                class: _normalizeClass(["wizard-history-item", {
          'wizard-history-item--active': session.sessionId === _ctx.activeSessionId,
        }]),
                onClick: ($event: any) => (_ctx.$emit('select-session', session))
              }, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(session.mode === "chat" ? "Chat" : "Creator"), 1),
                  _createElementVNode("span", {
                    class: _normalizeClass(["wizard-history-status", `wizard-history-status--${session.status}`])
                  }, _toDisplayString(_ctx.formatStatus(session.status)), 3)
                ]),
                _createElementVNode("div", _hoisted_10, _toDisplayString(session.preview || "Untitled conversation"), 1),
                _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.formatTimestamp(session.updatedAt || session.createdAt)), 1)
              ], 10, _hoisted_7))
            }), 128))
          ]))
  ]))
}